import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/clases-de-multas/';

/**
 * GET SectoresDeMultaes
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getClasesDeMultas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET SectorDeMulta
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getClaseDeMulta = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST SectorDeMulta
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClaseDeMulta = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH SectorDeMulta
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchClaseDeMulta = async (id, _values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, _values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE SectorDeMulta
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteClaseDeMulta = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
